import { render } from "./RevenueExclVatCard.vue?vue&type=template&id=2135a06f&scoped=true"
import script from "./RevenueExclVatCard.vue?vue&type=script&lang=js"
export * from "./RevenueExclVatCard.vue?vue&type=script&lang=js"

import "./RevenueExclVatCard.vue?vue&type=style&index=0&id=2135a06f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2135a06f"]])

export default __exports__